import React from "react";

import { SelectFilter } from "@skydio/rivet-ui";

import { useSearchParam } from "hooks/searchParams";

interface Props {
  label?: string;
  onSelect?: () => void;
  paramKey: string;
}

const LoginOverridesFilter: React.FC<Props> = ({ label, onSelect, paramKey }) => {
  const [selectedLoginOverrides, setSelectedLoginOverrides] = useSearchParam(paramKey);
  return (
    <SelectFilter
      filterLabel={label ?? "Login Method Override"}
      isSearchable={false}
      selectionMode="single"
      className="min-w-[150px]"
      selectedKey={selectedLoginOverrides}
      isClearable
      onSingleSelectionChange={key => {
        setSelectedLoginOverrides(key as string);
        onSelect?.();
      }}
      items={[
        { key: "true", label: "Yes" },
        { key: "false", label: "No" },
      ]}
    >
      {item => <SelectFilter.Item key={item.key}>{item.label}</SelectFilter.Item>}
    </SelectFilter>
  );
};

export default LoginOverridesFilter;
